import { format, isBefore, startOfDay } from "date-fns";
import { AlertTriangle } from "lucide-react";

export function OverdueActivitiesAlert({ activities, onActivityClick }) {
  const today = startOfDay(new Date());
  const overdue = activities.filter(
    (a) => a.status === "Planned" && isBefore(new Date(a.scheduled_at), today)
  );
  if (overdue.length === 0) return null;

  return (
    <div data-testid="overdue-alert" className="rounded-lg border border-destructive/30 bg-destructive/5 p-4">
      <div className="flex items-center gap-2 mb-3">
        <AlertTriangle className="h-5 w-5 text-destructive" />
        <h3 className="font-semibold text-destructive">{overdue.length} overdue {overdue.length === 1 ? "activity" : "activities"}</h3>
      </div>
      <div className="space-y-2">
        {overdue.slice(0, 5).map((a) => (
          <button key={a.id} data-testid={`overdue-${a.id}`} onClick={() => onActivityClick(a)}
            className="w-full text-left flex items-center justify-between p-2 rounded bg-background hover:bg-secondary transition-colors text-sm">
            <span className="font-medium">{a.business_name}</span>
            <span className="text-muted-foreground">{format(new Date(a.scheduled_at), "MMM d")}</span>
          </button>
        ))}
        {overdue.length > 5 && <p className="text-xs text-muted-foreground">+{overdue.length - 5} more</p>}
      </div>
    </div>
  );
}
